import React from 'react';
import {
    Link,
    useNavigate,
    useLocation
} from 'react-router-dom';
import {getCurrentUserRole} from '../utils/authHelper';
import {logout, isLoggedIn} from '../auth';
import '../styles/NavigationBar.css';

export default function NavigationBar() {
    const navigate = useNavigate();
    const location = useLocation();
    const role = getCurrentUserRole();

    const handleLogout = () => {
        logout();
        navigate('/');
    };

    const isActive = (path) => location.pathname.startsWith(path);

    return (
        <nav className="navbar">
            <div className="navbar-left">
                <img src="/logo.png" alt="Logo" className="logo"/>

                {role === 'admin' && (
                    <>
                        <div className={`nav-dropdown ${isActive("/customers") ? "active" : ""}`}>
                            <Link to="/customers" className="nav-dropdown-trigger">
                                Kunden
                            </Link>

                            <div className="nav-dropdown-menu">
                                <Link to="/customer_contacts" className="nav-dropdown-item">
                                    Kontakte
                                </Link>
                            </div>
                        </div>
                        <div className={`nav-dropdown ${isActive("/projects") ? "active" : ""}`}>
                            <Link to="/projects" className="nav-dropdown-trigger">
                                Projekte
                            </Link>

                            <div className="nav-dropdown-menu">
                                <Link to="/project_acquisition" className="nav-dropdown-item">
                                    Projektaquise
                                </Link>
                            </div>
                        </div>

                    </>
                )}

                <Link to="/timeentries" className={isActive('/timeentries') ? 'active' : ''}>Zeiterfassung</Link>
                <div className={`nav-dropdown ${isActive("/employee") ? "active" : ""}`}>
                    <Link to="/employee" className="nav-dropdown-trigger">
                        Mitarbeiterbreich
                    </Link>

                    {/* Only for admins */}
                    {role === "admin" && (
                        <div className="nav-dropdown-menu">
                            <Link to="/employee_profile" className="nav-dropdown-item">
                                Mitarbeiter
                            </Link>
                        </div>
                    )}
                </div>
                <Link to="/settings" className={isActive('/settings') ? 'active' : ''}>Einstellungen</Link>
            </div>
            <div className="navbar-right">
                {isLoggedIn() && (
                    <button onClick={handleLogout} className="button button-danger">
                        Logout
                    </button>
                )}
            </div>
        </nav>
    );
}
